import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/commerce/returns")({
	component: () => <Outlet />,
});
